import { defineComponent as z, computed as i, openBlock as n, createBlock as o, resolveDynamicComponent as d, normalizeClass as f, withCtx as S, renderSlot as k, unref as g, toRaw as C, createCommentVNode as u, createElementBlock as w, toDisplayString as L } from "vue";
import { RevCountryFlag as M } from "@ds/components/CountryFlag";
import "@ds/components/Icon";
import D from "../../icons/generated/IconChevronRight.vue2.js";
import { tw as e } from "../../utils/tailwind.js";
import { VariantsEnum as t, SizesEnum as l } from "./Pill.constant.js";
const P = /* @__PURE__ */ z({
  name: "RevPill",
  __name: "Pill",
  props: {
    size: { default: () => l.Medium },
    variant: { default: () => t.Default },
    isActionable: { type: Boolean, default: !1 },
    showChevron: { type: Boolean, default: !1 },
    label: {},
    prefixIcon: {},
    countryFlag: {},
    ariaLabel: {}
  },
  emits: ["click"],
  setup(a, { emit: v }) {
    const b = v, r = i(() => !!a.countryFlag), h = i(() => [
      e`rounded-full inline-flex max-w-full items-center`,
      // With flag: asymmetric padding, no gap (margins on label instead)
      // Without flag (icon or nothing): symmetric padding with gap
      r.value ? {
        [l.Small]: e`h-28 pl-10 pr-8`,
        [l.Medium]: e`h-36 pl-12 pr-8`,
        [l.Large]: e`h-[42px] pl-16 pr-10`
      }[a.size] : {
        [l.Small]: e`h-28 px-6`,
        [l.Medium]: e`h-36 px-10`,
        [l.Large]: e`h-[42px] px-12`
      }[a.size],
      {
        [t.Default]: e`bg-static-default-mid text-static-default-mid`,
        [t.Success]: e`bg-static-success-low text-static-success-hi`,
        [t.Danger]: e`bg-static-danger-low text-static-danger-hi`
      }[a.variant],
      a.isActionable && [
        e`cursor-pointer`,
        e`outline-2 outline-offset-2 focus-visible:outline-default-hi`,
        e`motion-safe:transition-colors motion-safe:duration-300`,
        {
          [t.Default]: e`hover:bg-static-default-mid-hover`,
          [t.Success]: e`hover:bg-static-success-low-hover`,
          [t.Danger]: e`hover:bg-static-danger-low-hover`
        }[a.variant]
      ]
    ]), x = i(() => [
      e`truncate`,
      {
        [l.Small]: e`caption`,
        [l.Medium]: e`body-2`,
        [l.Large]: e`body-1`
      }[a.size],
      // Label wrapper padding: symmetric without flag, asymmetric with flag
      r.value ? {
        [l.Small]: e`ml-6 mr-2`,
        [l.Medium]: e`ml-6 mr-4`,
        [l.Large]: e`ml-8 mr-6`
      }[a.size] : {
        [l.Small]: e`mx-4`,
        [l.Medium]: e`mx-4`,
        [l.Large]: e`mx-6`
      }[a.size]
    ]), c = i(
      () => ({
        [l.Small]: "16",
        [l.Medium]: "20",
        [l.Large]: "24"
      })[a.size]
    ), m = i(
      () => ({
        [l.Small]: "extra-small",
        [l.Medium]: "small",
        [l.Large]: "medium"
      })[a.size]
    );
    function y(s) {
      a.isActionable && b("click", s);
    }
    return (s, A) => (n(), o(d(a.isActionable ? "button" : "span"), {
      "aria-label": a.label ? void 0 : a.ariaLabel,
      class: f(h.value),
      type: a.isActionable ? "button" : void 0,
      onClick: y
    }, {
      default: S(() => [
        k(s.$slots, "prefix", {
          flagSize: m.value,
          iconSize: c.value
        }, () => [
          a.countryFlag ? (n(), o(g(M), {
            key: 0,
            "country-code": a.countryFlag,
            "data-test": "pill-country-flag",
            size: m.value
          }, null, 8, ["country-code", "size"])) : a.prefixIcon ? (n(), o(d(C(a.prefixIcon)), {
            key: 1,
            "data-test": "pill-prefix-icon",
            size: c.value
          }, null, 8, ["size"])) : u("", !0)
        ]),
        a.label ? (n(), w("span", {
          key: 0,
          class: f(x.value),
          "data-test": "pill-label"
        }, L(a.label), 3)) : u("", !0),
        a.isActionable && a.showChevron ? (n(), o(g(D), {
          key: 1,
          "data-test": "pill-chevron",
          size: c.value
        }, null, 8, ["size"])) : u("", !0)
      ]),
      _: 3
    }, 8, ["aria-label", "class", "type"]));
  }
});
export {
  P as default
};
